import React, { useState } from "react";
import { Page, Grid, Card, Button } from "tabler-react";
import SiteWrapper from "../../SiteWrapper";
import * as ticketService from "../../store/services/ticketServices";

function NewTicket(props) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [form, setForm] = useState({
        subject: "",
        category: "general",
        priority: "normal",
        body: "",
    });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setError("");

        if (!form.subject.trim() || !form.body.trim()) {
            setError("Subject and message are required.");
            return;
        }

        setLoading(true);
        ticketService
            .createTicket(form)
            .then((res) => {
                const id = res.data?.data?.id;
                props.history.push(`/tickets/${id}`);
            })
            .catch((err) => {
                setError(err?.response?.data?.message || "Failed to create ticket.");
                setLoading(false);
            });
    };

    return (
        <SiteWrapper loading={loading}>
            <Page.Content>
                <div className="page-header">
                    <h1 className="page-title">New Ticket</h1>
                </div>
                <Grid.Row>
                    <Grid.Col md={8}>
                        <Card>
                            <Card.Header>
                                <Card.Title>Submit a Support Request</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                {error && (
                                    <div className="alert alert-danger">{error}</div>
                                )}
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group">
                                        <label className="form-label">Subject</label>
                                        <input
                                            type="text"
                                            name="subject"
                                            className="form-control"
                                            value={form.subject}
                                            onChange={handleChange}
                                            placeholder="Brief description of your issue"
                                        />
                                    </div>
                                    <div className="form-group" style={{ marginTop: 16 }}>
                                        <label className="form-label">Category</label>
                                        <select
                                            name="category"
                                            className="form-control"
                                            value={form.category}
                                            onChange={handleChange}
                                        >
                                            <option value="general">General</option>
                                            <option value="billing">Billing</option>
                                            <option value="technical">Technical</option>
                                        </select>
                                    </div>
                                    <div className="form-group" style={{ marginTop: 16 }}>
                                        <label className="form-label">Priority</label>
                                        <select
                                            name="priority"
                                            className="form-control"
                                            value={form.priority}
                                            onChange={handleChange}
                                        >
                                            <option value="low">Low</option>
                                            <option value="normal">Normal</option>
                                            <option value="high">High</option>
                                            <option value="urgent">Urgent</option>
                                        </select>
                                    </div>
                                    <div className="form-group" style={{ marginTop: 16 }}>
                                        <label className="form-label">Message</label>
                                        <textarea
                                            name="body"
                                            className="form-control"
                                            rows={6}
                                            value={form.body}
                                            onChange={handleChange}
                                            placeholder="Describe your issue in detail..."
                                        />
                                    </div>
                                    <div style={{ marginTop: 20, display: "flex", gap: 10 }}>
                                        <Button type="submit" className="btn-mm">
                                            Submit Ticket
                                        </Button>
                                        <Button
                                            color="secondary"
                                            onClick={() => props.history.push("/tickets")}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                </form>
                            </Card.Body>
                        </Card>
                    </Grid.Col>
                </Grid.Row>
            </Page.Content>
        </SiteWrapper>
    );
}

export default NewTicket;
